import axios from "axios";
import axiosRetry from "axios-retry";
import { BRAND_LIST, COUNTRY } from "@type/index";
import { FETCH_TIMEOUT_MILLIS } from "@config/common";
import {
  reqErrHandler,
  reqHandler,
  resErrHandler,
  resHandler
} from "@util/net/interceptors";
import store from "@redux/store";

const relativePath = () => {
  const { region, brand_name } = store.getState().config;
  // GUHK
  if (region === COUNTRY.HK && brand_name === BRAND_LIST.GU) {
    let domain = "";
    if (process.env.NODE_ENV !== "development") {
      if (window.location.origin.includes("sit")) {
        domain = "https://sit-ext-api.gu-global.com";
      } else if (window.location.origin.includes("stg")) {
        domain = "https://stg-ext-api.gu-global.com";
      } else {
        domain = "https://d.gu-global.com";
      }
    }
    return `${domain}/${region}/crm`;
  }
  // GUTW
  else if (region === COUNTRY.TW && brand_name === BRAND_LIST.GU) {
    let domain = "";
    if (process.env.NODE_ENV !== "development") {
      if (window.location.origin.includes("sit")) {
        domain = "https://d-sit.gu-global.com";
      } else if (window.location.origin.includes("stg")) {
        domain = "https://d-uat.gu-global.com";
      } else {
        domain = "https://d.gu-global.com";
      }
    }
    return `${domain}/${region}`;
  }
  // UQTW
  else if (region === COUNTRY.TW && brand_name === BRAND_LIST.UQ) {
    let domain = "";
    if (process.env.NODE_ENV !== "development") {
      if (window.location.origin.includes("sit")) {
        domain = "https://d-sit.uniqlo.com";
      } else if (window.location.origin.includes("stg")) {
        domain = "https://d-uat.uniqlo.com";
      } else {
        domain = "https://d.uniqlo.com";
      }
    }
    return `${domain}/${region}`;
  }
  // UQHK
  else {
    let domain = "";
    if (process.env.NODE_ENV !== "development") {
      if (window.location.origin.includes("sit")) {
        domain = "https://co-dsit.uniqlo.com.hk";
      } else if (window.location.origin.includes("uat")) {
        domain = "https://co-duat.uniqlo.com.hk";
      } else if (window.location.origin.includes("stg")) {
        domain = "https://stg-ext-api.uniqlo.com.hk";
      } else {
        domain = "https://d.uniqlo.com.hk";
      }
    }
    return domain;
  }
};

const relativeConfig = (config?: any) => ({
  ...config
});

const instance = axios.create({
  timeout: FETCH_TIMEOUT_MILLIS
});

axiosRetry(instance, {
  retries: 2,
  retryDelay: (retryCount) => retryCount * 1000
});

instance.interceptors.request.use(reqHandler, reqErrHandler);
instance.interceptors.response.use(resHandler, resErrHandler);

const get = async (url: string, config?: any) => {
  const response = await instance.get(
    `${relativePath()}${url}`,
    relativeConfig(config)
  );
  return response;
};

const post = async (url: string, payload?: any, config?: any) => {
  const response = await instance.post(
    `${relativePath()}${url}`,
    payload,
    relativeConfig(config)
  );
  return response;
};

export default {
  get,
  post
};
